import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { buttonLinkReset, cssColorValue, cssSpacing, focusBorderWidth, focusBottomBorder, rootStyle, semanticColors } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var StyledButton = styled.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-1o9csmn-0"
})(["", ";", ";", ";display:flex;align-items:center;text-align:start;padding-inline-start:", ";padding-block:0;font-feature-settings:'tnum';color:", ";", ""], function (props) {
  return buttonLinkReset(props.$useBrowserDefaultFocusStyle);
}, rootStyle(), function (props) {
  return !props.$useBrowserDefaultFocusStyle && focusBottomBorder(focusBorderWidth, props.$isUsingKeyboard);
}, cssSpacing('tighter-2', '8px'), cssColorValue(semanticColors.textBase), function (props) {
  return props.$isFocus && !props.$useBrowserDefaultFocusStyle && css(["&::after{border-color:", ";}"], cssColorValue(semanticColors.essentialBase));
});
export var Button = /*#__PURE__*/React.forwardRef(function Button(_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement(StyledButton, Object.assign({
    ref: ref
  }, props));
});